import { ContactState } from './contact/contact.reducer';
import { GeneralState } from './general.reducer';
import { GuidelinesState } from './guidelines.reducer';
import { PagesState } from './pages/pages.reducer';
import { SearchState } from './search/search.reducer';

export const INIT_STATE_CONTACT: ContactState = {
  form: {
    labels: {
      company_name: 'Company name',
      email: 'E-Mail address *',
      first_name: 'First name *',
      func: 'Function',
      question: 'Your question *',
      role: 'Role',
      submit_button: 'Send',
    },
    feedback: {
      error: 'Oops! Something went wrong. Please try again later.',
      success: 'Thank you! Your form has been submitted successfully.'
    }
  },
  firstBlockTitle: 'Get in Touch with Us',
  firstBlockText: '<p>Whether you have questions, feedback, or are ready to join us on the journey toward a circular economy, we&rsquo;re here to help. Reach out to learn more about our resources, partnerships, and how you can be part of the change.</p>',
  secondBlockTitle: 'Quick contact',
  secondBlockText: '<p>Provide direct contact details for users who may want to reach out directly. This section should be compact and easy to spot. <br />Email: <a href="mailto:contact@d4c.com">contact@d4c.com </a><br />Phone: +123-456-7890</p>'
};

export const INIT_GENERAL_STATE: GeneralState = {
  role: null,
  searchLabel: 'Search',
  contactLabel: 'Contact',
  navigationFilters: [
    {
      uuid: '',
      name: 'Supplier',
      filter: 'supplier',
    },
    {
      uuid: '',
      name: 'Manufacturer',
      filter: 'manufacturer',
    },
    {
      uuid: '',
      name: 'Retailer',
      filter: 'retailer',
    },
    {
      uuid: '',
      name: 'Dismantler',
      filter: 'dismantler',
    },
  ],
  navigationGroups: [],
  settings: {
    contact: {
      email: 'emailaddress@d4c.be',
      phone: '+32 0478 88 77 66',
    },
    socials: {
      facebook: 'https:\/\/fb.com\/d4c',
      linkedin: 'https:\/\/linkedin.com\/d4c',
      x: 'https:\/\/x.com\/d4c',
      instagram: 'https:\/\/instagram\/d4c',
      youtube: 'https:\/\/youtube.com\/d4c',
    },
    poweredBy: 'DC - POWERED BY VALUMAT & WOOD.BE',
  },
  translates: {
    address: 'streetname streetname 12345A\r\nAntwerpen, 2000\r\nBelgi\u00eb',
    'address-information': 'Address information',
    'contact-information': 'Contact information',
    'footer-organisation-note': "This initiative is brought to you by Valumat and Wood.be -two organizations dedicated to building a sustainable, circular future for the mattress industry. By combining expertise in material management and innovation, they provide the guidance, knowledge, and resources needed to make circular design a reality.\r\nTogether, we're creating a comprehensive platform for a more eco-conscious industry.",
    contactFormSuccess: 'Thanks for contacting us.',
    contactFormRequiredError: 'Required',
    contactFormServerError: 'Apologies, we could not process the form right now. Try again later.',
    'search-no-result': 'No results. Try another filter',
    'clear-guidelines-filters': 'Reset filter',
    'guidelines-detail-btn-text': 'Details',
    'guidelines-table-header-title': 'Title',
    'guidelines-table-header-description': 'Description',
    'guidelines-table-header-presets': 'Presets',
    'guidelines-table-header-category': 'Category',
    'guidelines-table-header-action': 'Action',
    'home': 'Home',
    'click-to-zoom': 'Click to zoom',
    "guidelines-chart1-intro": "Improvement level based on [SELECTED_COUNT] selected guidelines out of [TOTAL_COUNT] total",
    "guidelines-chart1-title": "Your improvement on Eco-design :",
    "guidelines-chart2-intro": "Distribution for the different phases of lifecycle ",
    "guidelines-chart2-title": "Your selection ",
    "guidelines-filter-categories": "Categories",
    "guidelines-filter-presets": "Presets",
    "guidelines-download-btn-text": "Download",
  },
};

export const INIT_PAGES_STATE: PagesState = {
  activePage: null,
  root: null,
  rootLanguage: null,
  cms: {},
  contact: null,
  privacyPolicy: null,
  search: null,
};

export const INIT_SEARCH_STATE: SearchState = {
  searchString: '',
  results: [],
};

export const INIT_GUIDELINES_STATE: GuidelinesState = {
  strategies: [],
  selectedRows: new Set<string>(),
  filters: {
    categories: [],
    presets: []
  },
  categories: [],
  presets: [],
  ui: {
    openStrategyId: null,
    focusGuidelineId: null,
  }
};
